import { convertTimestampSecondsToMs } from '@shared/helpers/date';
import { parseWei } from '@shared/helpers/web3/formatters';

import { PredictionDirection } from '../../model/PredictionDirection';
import type { PredictionEntry } from '../../model/PredictionEntry';
import { RoundResult } from '../../model/RoundResult';
import type { UserPredictionRoundsDto } from './types';

interface GetRoundResultProps {
  userChoice: PredictionDirection;
  wonAmount: number;
  isDraw: boolean;
}

const getRoundResult = ({ userChoice, wonAmount, isDraw }: GetRoundResultProps): RoundResult => {
  if (isDraw) {
    return RoundResult.DRAW;
  }

  const isWinner = wonAmount > 0;

  const oppositeUserChoice =
    userChoice === PredictionDirection.UP ? PredictionDirection.DOWN : PredictionDirection.UP;

  const resolvedDirection = isWinner ? userChoice : oppositeUserChoice;

  return resolvedDirection === PredictionDirection.UP ? RoundResult.UP : RoundResult.DOWN;
};

export const dataMapper = (roundsDto: UserPredictionRoundsDto): PredictionEntry[] => {
  return roundsDto
    .map((roundDto) => {
      const wonAmount = parseWei({
        wei: BigInt(roundDto.won.toString()),
        tokenName: 'USDT',
        formatOptions: {
          stableToDollar: false,
        },
      });

      const userBet = parseWei({
        wei: BigInt(roundDto.amount.toString()),
        tokenName: 'USDT',
        formatOptions: {
          stableToDollar: false,
        },
      });

      const userChoice =
        roundDto.position === 1 ? PredictionDirection.DOWN : PredictionDirection.UP;

      const roundResult = getRoundResult({
        userChoice,
        wonAmount: wonAmount.value,
        isDraw: roundDto.draw,
      });

      return {
        id: Number(roundDto.roundId),
        roundId: Number(roundDto.roundId),
        closeTimestamp: convertTimestampSecondsToMs(Number(roundDto.closeTimestamp)),
        wonAmount,
        isClaimed: roundDto.claimed,
        userChoice,
        roundResult,
        userBet,
      };
    })
    .sort((a, b) => b.roundId - a.roundId);
};
